import { DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderMoveStopsTableQuickInfo extends Layout {
    panelContent: Panel;
    sourceOrderCurrentMoveStops: DataSource;
    sourceStop: DataSource;
    tableStop: Table;
    textboxBillDistance: Textbox;
    textboxFreightCharge: Textbox;
    textboxId: Textbox;
    textboxMovementId: Textbox;
}
